<template>
    <mu-row>
        <mu-col width="5" tablet="5" desktop="5">栅</mu-col>
        <mu-col width="5" tablet="5" desktop="5">格</mu-col>
        <mu-col width="5" tablet="5" desktop="5">布</mu-col>
        <mu-col width="5" tablet="5" desktop="5">局</mu-col>
    </mu-row>
</template>
<script>
export default {
    name: 'shanGe'
}
</script>



// WEBPACK FOOTER //
// shanGe.vue?aa0afc94